import React, {PropsWithChildren} from 'react'

import {Alignment} from '../../types/createStylesParams'

import {classes, st} from './styles.st.css'

interface ButtonAlignmentProps {
  alignment: Alignment
  className?: string
}

export const ButtonAlignment: React.FC<PropsWithChildren<ButtonAlignmentProps>> = ({
  children,
  alignment,
  className,
}) => {
  return <div className={st(ButtonAlignmentToClass[alignment], className)}>{children}</div>
}

export const ButtonAlignmentToClass: Record<Alignment, string> = {
  [Alignment.Left]: classes.alignStart,
  [Alignment.Center]: classes.alignCenter,
  [Alignment.Right]: classes.alignEnd,
  [Alignment.Stretch]: classes.alignInitial,
}

interface TextAlignmentProps {
  alignment: Alignment
  className?: string
}

export const TextAlignment: React.FC<PropsWithChildren<TextAlignmentProps>> = ({
  children,
  alignment,
  className,
}) => {
  return <div className={st(TextAlignmentToClass[alignment], className)}>{children}</div>
}

export const TextAlignmentToClass: Record<Exclude<Alignment, Alignment.Stretch>, string> = {
  [Alignment.Left]: classes.textLeft,
  [Alignment.Center]: classes.textCenter,
  [Alignment.Right]: classes.textRight,
}
